var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin":"10px 10px 0 0","border":"0px solid red"}},[_c('form-create',{attrs:{"rule":_vm.mergedRule,"option":_vm.option},on:{"submit":_vm.onSubmit}})],1),_c('div',{staticStyle:{"height":"100px","background-color":"transparent"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }